import('../app/oauth.js');
import('../app/auth-listen.js');
import('../vendor/bootstrap.min.js');
import('../app/promo/tooltip/tooltip.js');
import('../vendor/plugins/hello.all.min.js');
import('../app/main.js');
import('../app/social-auth.js');
import('../app/inst.js');

import('../app/security/login/login-email.js');
import('../app/security/login/login-social.js');
import('../app/security/reg/reg-email.js');
import('../app/security/reg/reg-email-code.js');
import('../app/security/reg/reg-set-pass.js');
import('../app/security/forgot/forgot-email.js');
import('../app/security/forgot/forgot-email-code.js');
import('../app/security/forgot/forgot-set-pass.js');

if (AUTH_TYPE.PHONE) {
    import('../app/security/login/login-phone.js');
    import('../app/security/reg/reg-phone.js');
    import('../app/security/reg/reg-phone-code.js');
    import('../app/security/forgot/forgot-phone.js');
    import('../app/security/forgot/forgot-phone-code.js');
}